import React from 'react'
import Header from '../component/header'
import BannerImg from '../image/contact.png'
import Banner from '../component/Banner'
import Footer from '../component/Footer'
import Spotlight from '../component/Spotlight'
import Forms from '../component/contact/Form'
import Foundation from '../component/contact/Foundation'
import Help from '../component/contact/Help'
const Contact = () => {
  return (
 <>
    <Header />
          <Banner
            backgroundImage={BannerImg}
            heading="We’re here to support your creative journey"
            paragraph="Whether you have a question about challenges, education, membership, or partnerships, the Lightweave Beacon Legacy team is ready to help. Reach out with confidence—this is a welcoming space built on respect, clarity, and support."
            minHeight="100vh"
            padding="80px 0"
            bton="Members please sign-in"
          />
          <Forms/>
          <Foundation/>
          <Help/>
          <Spotlight/>
          <Footer />
    
    </>
  )
}

export default Contact;
